import {action} from "mobx";
import courierBonusCampaignService from "../services/courierBonusCampaignService";
import appStore from "./appStore";

class courierBonusCampaignStore {
    @action listCourierBonusCampaigns = async params => {
        const resultOfRequest = await courierBonusCampaignService.listCourierBonusCampaigns(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createCourierBonusCampaign = async params => {
        const resultOfRequest = await courierBonusCampaignService.createCourierBonusCampaign(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateCourierBonusCampaign = async params => {
        const resultOfRequest = await courierBonusCampaignService.updateCourierBonusCampaign(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action deleteCourierBonusCampaign = async params => {
        const resultOfRequest = await courierBonusCampaignService.deleteCourierBonusCampaign(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new courierBonusCampaignStore();
